export const statementText = (title: string) => {
  switch (title) {
    case "使用者協議":
      return [
        {
          title: "隱私權保護政策的適用範圍",
          content: [
            "隱私權保護政策內容，包括本網站如何處理在您使用網站服務時收集到的個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。",
          ],
        },
        {
          title: "個人資料的蒐集、處理及利用方式",
          content: [
            "本網站隸屬之網域並無發行第一方 Cookie，您可在您使用的瀏覽器功能項中封鎖或拒絕本網站隸屬之網域 Cookie 寫入，並不會導致網站功能無法正常執行。",
            "本網站有使用第三方 Cookie，第三方 Cookie 是由不屬於本網站隸屬之網域所發行的 Cookie，若您不願接受其他網域所發行之 Cookie 的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕第三方 Cookie 的寫入或是拒絕任何 Cookie 的寫入，但可能會導致網站某些功能無法正常執行 。",
          ],
        },
      ];
    default:
      [];
  }
};
